'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useTranslations, useLocale } from 'next-intl';
import LocaleChange from '@/app/lib/localeChange';
import { useRouter, usePathname, Link as LocaleLink } from '@/app/i18n/navigation';

export default function Header() {
  const t = useTranslations('Header');
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onSelectLanguage = async (newLocale: string) => {
    if (locale !== newLocale) {
      document.cookie = `NEXT_LOCALE=${newLocale}; path=/; max-age=31536000; SameSite=Lax`;
      LocaleChange(newLocale);
    }
  };

  function scrollToElement(section: string) {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      return true;
    }
    return false;
  }

  function scrollInSection(section: string) {
    if (pathname === '/') {
      scrollToElement(section);
      return;
    }

    router.push('/');
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (scrollToElement(section) || attempts > 20) {
        clearInterval(interval);
      }
    }, 100);
  }

return (
    <>
      <header className="bg-light m-3 rounded-full">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex-shrink-0">
              <Link href="/">
                <Image
                  src={'/images/logo.png'}
                  alt={`screenshot`}
                  className="h-auto justify-self-center"
                  width={100}
                  height={60}
                // style={imageStyle}
                />
              </Link>
            </div>
              <nav className="hidden md:flex flex-grow justify-center">
                <ul className="flex space-x-8 items-center">
                  {/* <li><button onClick={() => {scrollInSection('why_kidoor')}} className={`cursor-pointer hover:color-primary-light color-primary px-3 py-2 rounded-md text-md font-medium`}>{t('why_kidoor')}</button></li>
                  <li><button onClick={() => {scrollInSection('categories')}} className={`cursor-pointer hover:color-primary-light color-primary px-3 py-2 rounded-md text-md font-medium`}>{t('categories')}</button></li>
                  <li><button onClick={() => {scrollInSection('for_who')}} className={`cursor-pointer hover:color-primary-light color-primary px-3 py-2 rounded-md text-md font-medium`}>{t('for_who')}</button></li>
                  <li><button onClick={() => {scrollInSection('values')}} className={`cursor-pointer hover:color-primary-light color-primary px-3 py-2 rounded-md text-md font-medium`}>{t('values')}</button></li> */}
                  <li><LocaleLink href={'/classes-services'} className={`cursor-pointer hover:color-primary-light color-primary px-3 py-2 rounded-md text-md font-medium`}>{t('classes_services')}</LocaleLink></li>
                  <li><a href={'/about-us'} rel="noopener noreferrer" className={`cursor-pointer hover:color-primary-light color-primary px-3 py-2 rounded-md text-md font-medium`}>{t('about')}</a></li>
                  <li><LocaleLink href={'/blog'} className={`cursor-pointer hover:color-primary-light color-primary px-3 py-2 rounded-md text-md font-medium`}>{t('blog')}</LocaleLink></li>
                </ul>
              </nav>
             <div className="flex">
              <button id="menu-toggle" aria-label='menu-toggle' type="button" onClick={() => setIsOpen(true)} className="md:hidden inline-flex items-center cursor-pointer justify-center p-2 rounded-md text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-expanded="false">
                <svg className="block h-12 w-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 44" stroke="#000" aria-hidden="true">
                  <path strokeLinecap="square" strokeLinejoin="round" strokeWidth="2" d="M0 17h44M1 23h44M1 29h44" />
                </svg>
                <svg className="hidden h-12 w-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="#000" aria-hidden="true">
                  <path strokeLinecap="square" strokeLinejoin="round" strokeWidth="2" d="M1 6h18M1 12h18M1 18h18" />
                </svg>
              </button>
            </div>
            <div className="hidden md:flex gap-4">
              <div className='w-full flex gap-2 justify-end mb-1'>
                <button className='text-primary text-sm cursor-pointer hover:text-orange-300' onClick={() => {onSelectLanguage('en')}}>
                  EN {" | "}
                </button>
                <button className='text-primary text-sm cursor-pointer hover:text-orange-300' onClick={() => {onSelectLanguage('sq')}}>
                  SQ
                </button>
              </div>
              
              <a href='/contact-us' className="inline-flex items-center w-100 cursor-pointer justify-center py-2 px-8 rounded-full text-white bg-primary focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                {t('contact_us')}
              </a>
            </div>
          </div>
        </div>

        <div
          className={`fixed inset-0 bg-primary z-50
                    flex flex-col md:flex-row items-center justify-start transition-transform duration-500
                    ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
        >
          <button
            onClick={() => setIsOpen(false)}
            aria-label="close"
            className="absolute top-6 right-6 text-white cursor-pointer hover:text-slate-100"
          >
            ✕
          </button>

          <nav className="flex flex-col justify-center items-start px-4 md:px-40 space-y-6 mt-10">
            <div className='w-full flex gap-2 justify-end mb-1'>
              <button className='text-white text-2xl cursor-pointer hover:text-orange-300' onClick={() => {onSelectLanguage('en')}}>
                EN {" | "}
              </button>
              <button className='text-white text-2xl cursor-pointer hover:text-orange-300' onClick={() => {onSelectLanguage('sq')}}>
                SQ
              </button>
            </div>
            <hr className='w-full text-gray-500 border opacity-20 mb-12' />
            {[
              // { name: "home", href: "/" },
              // { name: "why_kidoor", href: "#why_kidoor" },
              // { name: "categories", href: "#categories" },
              // { name: "for_who", href: "#for_who" },
              // { name: "values", href: "#values" },
              { name: "about", href: "/about-us" },
              { name: "classes_services", href: "/classes-services" },
              { name: "blog", href: "/blog" },
            ].map((item, index) => (
              <Link
                key={item?.href}
                href={item?.href}
                onClick={() => setIsOpen(false)}
                className="relative group transition-colors flex justify-between w-full"
              >
                <div className='flex gap-4 items-end'>
                  <span className="group-hover:text-orange-300 transition-colors text-4xl md:text-7xl text-white font-semibold">
                    {t(item?.name)}
                  </span>
                </div>
              </Link>
            ))}
            <hr className='w-full text-gray-500 border opacity-20 mt-4' />
            <div className='w-full flex gap-8'>
              <Image
                src={"/images/logo.png"}
                width={100}
                height={20}
                alt="primalt_logo"
              />
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}
